import React from "react";
import { CircularAvatar } from "../../commons";
import { components } from "react-select";
import ReactDatePicker from "react-datepicker";
import { Label } from "reactstrap";
import { CalenderIcon } from "../../Icon";
import moment from "moment";
import Select from "react-select";
export type DropDownUserType = {
  value: number | null;
  label: string;
};

type AppProps = {
  startDate: string;
  token: string | null;
  endDate: string;
  handleStartDateChange?: (date: string) => void;
  handleEndDateChange?: (date: string) => void;
  handleSubmitData?: () => void;
  limit: number;
  userWiseOCRReportList: any[] | [];
  currentStartDate: string;
  currentEndDate: string;
  finalUserList?: DropDownUserType[];
  user?: DropDownUserType;
  userFetching?: boolean;
  setUser?: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  setUserOffset?: React.Dispatch<React.SetStateAction<number>>;
  setUserText?: React.Dispatch<React.SetStateAction<string>>;
  type?: string;
};

const ORCReportHeader = ({
  startDate,
  token,

  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData,
  userFetching,
  limit,
  currentStartDate,
  currentEndDate,
  finalUserList,
  user,
  setUser,
  setUserOffset,
  setUserText,
  type
}: AppProps) => {
  const checkBottom = () => {
    setUserOffset && setUserOffset((prev: number) => prev + 20);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          {data?.label !== "All" ? 
          <CircularAvatar
          name={data?.label.split("%")[0]}
          image={data?.image && data?.image}
          />:
          (<>
          </>)
        }
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  return (
    <>
      <div
        style={{ display: "flex", alignItems: "start" }}
        className="pt-3 pl-3"
      >
        <div className="col-md-3 form-group d-flex flex-column">
          <label className="mb-1" htmlFor="">
           {type === "User" ? "User Name" : "Client Name"}
          </label>
          <Select
            // onMenuClose={onMenuClose}
            components={{ Option }}
            isSearchable={true}
              options={[{ value: null, label: "All" }, ...(finalUserList ?? [])]}
            isLoading={userFetching}
            value={user}
            onMenuScrollToBottom={(e: any) => checkBottom()}
            onChange={(value: any) => setUser && setUser(value)}
            onInputChange={(e) => {
              setUserText && setUserText(e);
              setUserOffset && setUserOffset(0);
            }}
          />
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <div className="date-picker-wraper mr-0">
              <Label className="m-0 p-0 w-100">
                <label className="mb-1" htmlFor="">
                  Start Date <span className="text-danger">*</span>
                </label>
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    startDate
                      ? new Date(
                          moment(`${startDate}T00:00:00`, "YYYY-MM-DD").format(
                            "YYYY-MM-DD[T]HH:mm:ss"
                          )
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleStartDateChange?.(moment(e).format("YYYY-MM-DD"));
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="dateOfInvoice"
                  placeholderText="Start Date"
                  className="form-control"
                />
                <span
                  className="calender-icon"
                  style={{
                    right: "30px",
                    cursor: "pointer",
                    marginTop: "25px",
                  }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <div className="date-picker-wraper mr-0">
              <Label className="m-0 p-0 w-100">
                <label className="mb-1" htmlFor="">
                  End Date <span className="text-danger">*</span>
                </label>
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    endDate
                      ? new Date(
                          moment(`${endDate}T00:00:00`, "YYYY-MM-DD").format(
                            "YYYY-MM-DD[T]HH:mm:ss"
                          )
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleEndDateChange?.(moment(e).format("YYYY-MM-DD"));
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="dateOfInvoice"
                  placeholderText="End Date"
                  className="form-control"
                  minDate={
                    startDate
                      ? new Date(moment(startDate).format("YYYY-MM-DD"))
                      : null
                  }
                  maxDate={
                    startDate
                      ? new Date(
                          moment(startDate).add(31, "days").format("YYYY-MM-DD")
                        )
                      : null
                  }
                />
                <span
                  className="calender-icon"
                  style={{
                    right: "30px",
                    cursor: "pointer",
                    marginTop: "25px",
                  }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>

        <div className="col-md-3" style={{ marginTop: "28px" }}>
          <button
            className="btn btn-primary"
            onClick={handleSubmitData}
            disabled={!startDate?.length || !endDate?.length}
          >
            Get Report
          </button>
        </div>
      </div>
    </>
  );
};

export default ORCReportHeader;
